import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { FullSpinner } from "@/components/States";
import { toast } from "sonner";

export default function Preferences() {
  const [pref, setPref] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/profile/me").then(({ data }) => setPref(data.profile.partner_preference || {})); }, []);
  if (!pref) return <FullSpinner />;
  const set = (k, v) => setPref((p) => ({ ...p, [k]: v }));

  const save = async () => {
    setBusy(true);
    try {
      const clean = { ...pref };
      if (typeof clean.cities === "string") clean.cities = clean.cities.split(",").map((s) => s.trim()).filter(Boolean);
      await api.put("/profile/me", { data: { partner_preference: clean } });
      toast.success("Partner preferences saved");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  const cities = Array.isArray(pref.cities) ? pref.cities.join(", ") : (pref.cities || "");

  return (
    <div className="max-w-3xl mx-auto space-y-5" data-testid="preferences-page">
      <div><h1 className="font-serif text-3xl font-bold text-[#58111A]">Partner Preferences</h1><p className="text-sm text-[#605255]">These directly improve your match quality.</p></div>
      <div className="mj-card p-5 grid sm:grid-cols-2 gap-4">
        <div><label className="mj-label">Looking for</label>
          <select className="mj-input" value={pref.gender || ""} onChange={(e) => set("gender", e.target.value)}>
            <option value="">Any</option><option>Female</option><option>Male</option>
          </select>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div><label className="mj-label">Age Min</label><input className="mj-input" type="number" value={pref.age_min || ""} onChange={(e) => set("age_min", e.target.value)} /></div>
          <div><label className="mj-label">Age Max</label><input className="mj-input" type="number" value={pref.age_max || ""} onChange={(e) => set("age_max", e.target.value)} /></div>
        </div>
        <div className="sm:col-span-2"><label className="mj-label">Preferred Cities (comma separated)</label><input className="mj-input" defaultValue={cities} onChange={(e) => set("cities", e.target.value)} placeholder="Bangalore, Hyderabad" /></div>
        <div><label className="mj-label">Religion</label><input className="mj-input" value={pref.religion || ""} onChange={(e) => set("religion", e.target.value)} /></div>
        <div><label className="mj-label">Community</label><input className="mj-input" value={pref.community || ""} onChange={(e) => set("community", e.target.value)} /></div>
        <div><label className="mj-label">Mother Tongue</label><input className="mj-input" value={pref.mother_tongue || ""} onChange={(e) => set("mother_tongue", e.target.value)} /></div>
        <div><label className="mj-label">Diet</label>
          <select className="mj-input" value={pref.diet || ""} onChange={(e) => set("diet", e.target.value)}>
            <option value="">Any</option><option>Vegetarian</option><option>Non-Vegetarian</option><option>Eggetarian</option><option>Vegan</option>
          </select>
        </div>
        <div className="sm:col-span-2 flex items-center gap-2">
          <input type="checkbox" id="reloc" checked={!!pref.relocation} onChange={(e) => set("relocation", e.target.checked)} className="w-4 h-4 accent-[#781826]" />
          <label htmlFor="reloc" className="text-sm text-[#261A1C]">Open to partner who needs to relocate</label>
        </div>
      </div>
      <button onClick={save} disabled={busy} data-testid="save-preferences" className="btn-primary w-full">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4" /> Save Preferences</>}</button>
    </div>
  );
}
